import script from "./FilesMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./FilesMessage.vue?vue&type=script&setup=true&lang=js"

import "./FilesMessage.vue?vue&type=style&index=0&id=57d270fb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57d270fb"]])

export default __exports__